var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"font-weight-medium",attrs:{"label":"","color":"grey darken-3","text-color":"white"}},[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.hesapla))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }